<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Group 11">
<circle id="Oval" cx="9" cy="9" r="9" fill="#FA5252"/>
<g id="Group 10">
<path id="Path 29" d="M5 5L13 13" stroke="white" strokeWidth="1.5"/>
<path id="Path 29_2" d="M5 13L13 5" stroke="white" strokeWidth="1.5"/>
</g>
</g>
</svg>
